import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { KC_MATERIAL_DATE_FORMATS } from 'src/app/Models/materialDatepickerConfig';
import { CmAddress } from 'src/app/client/shared-client.service';
import { XeroService } from 'src/app/settings/connections/xero/xero.service';
import { KcWarningPopupComponent } from '../kc-warning-popup/kc-warning-popup.component';
import { warningPopResponse } from 'src/app/shared/app.constant';

@Component({
  selector: 'app-ni-generateform-popup',
  standalone: true,
  imports: [
    CommonModule, FormsModule,
    MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatNativeDateModule,
    NgSelectModule, NgMultiSelectDropDownModule
  ],
  templateUrl: './ni-generateform-popup.component.html',
  styleUrls: ['./ni-generateform-popup.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: KC_MATERIAL_DATE_FORMATS}],
})

export class NiGenerateformPopupComponent implements OnInit, OnDestroy {
  @Input() clientData: any[];
  @Input() contactData: any[];
  @Input() changedPhysicalAddress: CmAddress;
  @Input() _tempClientDetails: {
    firstname?: string;
    middlename?: string;
    lastname?: string;
    dateofbirth?: string;
    clientId: number;
  };
  @Output() closePopup = new EventEmitter<void>();
  @Input() sourceComponent: string;
  @Input() contactTempId: number;
  @Input() selectedContact: {
    firstName?: string;
    middleName?: string;
    lastname?: string;
    dateOfBirth?: string;
  };
  @Input() changedNewPhyAddress: string = '';
  @Input() newPhyAddressId: number;
  @Input() newPhyAddresscareOf: string = '';
  isEnableEntityScreen: boolean = false;
  isFirstScreenVisible: boolean = true;
  isSecondScreenVisible: boolean = false;
  authorisorList: any[] = [];
  addressTypeList = [];
  addressTypeConfig = {};
  isPopupScrollLock:boolean=false;
  clientId: number;
  formattedAddress: string = '';
  selectedKloudId: string | null = null;
  warningPopupRes = warningPopResponse;
  clientConnectionId: string | null = null;
  contactId: number;
  tempContactDetails: any;
  newPhyAddressLine: any;
  selectedEntitiesForSecondScreen: any[] = [];
  unsubscribe = new Subject<void>();
  private modalRef: BsModalRef;

  constructor(private toastr: ToastrService, private xeroService: XeroService, private datePipe: DatePipe, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.clientId = Number(localStorage.getItem("clientid"));
    this.contactId = this.contactTempId;
    this.tempContactDetails = this.selectedContact;
    this.newPhyAddressLine = this.changedNewPhyAddress
    this.addressTypeList = [
      { item_id: 1, item_text: 'Registered' },
      { item_id: 2, item_text: 'Principal' }
    ];
    this.addressTypeConfig = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      enableCheckAll:false,
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    this.formatAddress();
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
 
  popupScrollLock(){
    this.isPopupScrollLock = true;
  }
  removepopupScrollLock(){
    this.isPopupScrollLock = false;
  }

  getSelectedEntities() {
    if (this.sourceComponent === 'contactComponent') {
      return this.clientData.filter(item => item.isChecked);
    } else if (this.sourceComponent === 'createContactComponent') {
      return this.contactData.filter(item => item.isChecked);
    }
    return [];
  }
  

  handleYesClick() {
    const selectedEntities = this.getSelectedEntities();
    if (selectedEntities.length > 0) {
      this.selectedEntitiesForSecondScreen = selectedEntities;
      if (this.selectedKloudId) {
        this.getClientNowInfinityRelationShips(this.selectedKloudId);
      }
      this.isFirstScreenVisible = false;
      this.isSecondScreenVisible = true;
    } else {
      this.showToastrMessage();
    }
  }

  handleNoClick() {
    this.modalRef = this.modalService.show(KcWarningPopupComponent, {
      class: 'modal-dialog-centered',
      backdrop: 'static',
      initialState: {
        mainContent: `You are about to cancel the form generation screen`,
      }
    });

    this.modalRef.content.event.subscribe(res => {
      if (res === this.warningPopupRes.YES) {
        this.modalService.hide();
      } else {
        this.isFirstScreenVisible = true;
      }
      this.modalRef?.hide();

    })
  }
  

  cancelPopUp() {
    this.modalRef = this.modalService.show(KcWarningPopupComponent, {
      class: 'modal-dialog-centered',
      backdrop: 'static',
      initialState: {
        mainContent: `You are about to cancel the form generation screen`,
      }
    });

    this.modalRef.content.event.subscribe(res => {
      if (res === this.warningPopupRes.YES) {
        this.modalService.hide();
      } else {
        this.isFirstScreenVisible = false;
      }
      this.modalRef?.hide();

    })
  }

  transformRole(role: string): string {
    if (!role) return '';
    return role.replace(/([A-Z][a-z]*)/g, ' $1').trim().replace(/ And /g, ' and ');
  }

  showToastrMessage(): void {
    this.toastr.error('To generate a form, select at least one company.', 'Error');
  }

  formatAddress() {
    const parts = [
      this.changedPhysicalAddress.addressline1,
      this.changedPhysicalAddress.addressline2,
      this.changedPhysicalAddress.suburb,
      this.changedPhysicalAddress.stateName,
      this.changedPhysicalAddress.postcode,
      this.changedPhysicalAddress.countryName
    ];

    this.formattedAddress = parts.filter(part => part).join(', ');
  }

  getClientNowInfinityRelationShips(kloudId: string) {
    const isContactComponent = this.sourceComponent === 'contactComponent';

    const entityId = isContactComponent ? this.clientId : this.contactId;
    this.xeroService.GetClientConnectionRelationShipsById('00000000-0000-0000-0000-000000000000',
      kloudId, 'NowInfinity').pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (response: any) => {

          const editedEntity = response.find((authorisor: any) => authorisor.kcid === entityId);

          if (editedEntity) {
            this.clientConnectionId = editedEntity.connectionId;
          }    
          
          this.authorisorList = this.transformAuthorisorData(response);
        }, error: (error: any) => {
          this.toastr.error(error.message);
        }
      });
  }

  onCheckboxChange(item: any) {
    if (item.isChecked) {
      this.selectedKloudId = item.relationKCID; 
      this.getClientNowInfinityRelationShips(this.selectedKloudId);
    } else {
      this.selectedKloudId = null;
      this.authorisorList = []; 
    }
  }

  transformAuthorisorData(response: any[]): any[] {
    return response.map(item => ({
      authorisorName: `${item.firstName} ${item.middleName ? item.middleName + ' ' : ''}${item.lastName}`,
      authorisorId: item.relationId,
      authorisorRole: item.role,
      dateOfBirth: item.dateOfBirth 
    }));
  }

  isFormValid(): boolean {
    return this.selectedEntitiesForSecondScreen.some(item =>
      item.effectiveDate &&
      item.authorizedUser &&
      item.signingManagerUsername
    );
  } 

  addEditAddressChangeSubmit() {
    const changedEntities = this.sourceComponent === 'contactComponent' ?
      this.clientData.map(client => {
        const isRegisteredSelected = client.addressType?.some((type: any) => type.item_text === 'Registered') || false;
        const isPrincipalSelected = client.addressType?.some((type: any) => type.item_text === 'Principal') || false;
        const authorisor = this.authorisorList.find(authorisorItem => authorisorItem.authorisorId === client.authorizedUser);

        return {
          companyId: client.uuid || null,
          contactId: "",
          connectionId: client.connectionId,
          effectiveDate: client.effectiveDate ? new Date(this.datePipe.transform(client.effectiveDate, 'yyyy-MM-dd')) : null,
          authorizedUser: client.authorizedUser || "",
          authorizedUserFirstName: authorisor ? authorisor.authorisorName.split(' ')[0] : "",
          authorizedUserMiddleName: authorisor ? authorisor.authorisorName.split(' ').slice(1, -1).join(' ') : "",
          authorizedUserLastName: authorisor ? authorisor.authorisorName.split(' ').slice(-1)[0] : "",
          authorizedUserDateOfBirth: authorisor ? new Date(this.datePipe.transform(authorisor.dateOfBirth, 'yyyy-MM-dd')) : null,
          signingManagerUsername: client.signingManagerUsername,
          isRegisteredAddress: isRegisteredSelected,
          isPrincipalAddress: isPrincipalSelected
        };
      })
      : this.contactData.map(contact => {
        const isRegisteredSelected = contact.addressType?.some((type: any) => type.item_text === 'Registered') || false;
        const isPrincipalSelected = contact.addressType?.some((type: any) => type.item_text === 'Principal') || false;
        const authorisor = this.authorisorList.find(authorisorItem => authorisorItem.authorisorId === contact.authorizedUser);

        return {
          companyId: contact.uuid || null,
          contactId: contact.kloudId ? contact.kloudId.toString() : null,
          connectionId: contact.connectionId || "",
          effectiveDate: contact.effectiveDate ? new Date(this.datePipe.transform(contact.effectiveDate, 'yyyy-MM-dd')) : null,
          authorizedUser: contact.authorizedUser || "",
          authorizedUserFirstName: authorisor ? authorisor.authorisorName.split(' ')[0] : "",
          authorizedUserMiddleName: authorisor ? authorisor.authorisorName.split(' ').slice(1, -1).join(' ') : "",
          authorizedUserLastName: authorisor ? authorisor.authorisorName.split(' ').slice(-1)[0] : "",
          authorizedUserDateOfBirth: authorisor ? new Date(this.datePipe.transform(authorisor.dateOfBirth, 'yyyy-MM-dd')) : null,
          signingManagerUsername: contact.signingManagerUsername,
          isRegisteredAddress: isRegisteredSelected,
          isPrincipalAddress: isPrincipalSelected
        };
      })
    let requestBody = {
      connectionType: 'NowInfinity',
      connectionId: this.clientConnectionId || null,
      clientId: this.sourceComponent === 'contactComponent' ? this._tempClientDetails.clientId : this.contactId,
      clientFirstName: this.sourceComponent === 'contactComponent' ? (this._tempClientDetails.firstname || "") : (this.tempContactDetails.firstName || ""),
      clientMiddleName: this.sourceComponent === 'contactComponent' ? (this._tempClientDetails.middlename || "") : (this.tempContactDetails.middleName || ""),
      clientLastName: this.sourceComponent === 'contactComponent' ? (this._tempClientDetails.lastname || "") : (this.tempContactDetails.lastname || ""),
      changedAddressDetails: {
        addressId: this.newPhyAddressId,
        contestId: this.sourceComponent === 'contactComponent' ? this.clientId : this.contactId,
        contestType: this.sourceComponent === 'contactComponent' ? 'Client' : 'Contact',
        careOf: this.newPhyAddresscareOf
      },
      changedEntities: changedEntities
    }
    this.xeroService.addSubmitAddressChangeForm(requestBody).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (response: any) => {
        if (response === "True") {
          this.toastr.success('Address change form submitted successfully.');
          this.modalService.hide();
        } else {
          this.toastr.error('Failed to submit address change form.');
          this.modalService.hide();
        }
      },
      error: (error: any) => {
        this.toastr.error('An error occurred while generating the form. Please try again.')
        this.modalService.hide()

      }
    });
  }

} 
